/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './paramedic-hospital-association.reducer';

export const ParamedicHospitalAssociationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const paramedicHospitalAssociationEntity = useAppSelector(state => state.paramedicHospitalAssociation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="paramedicHospitalAssociationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.paramedicHospitalAssociation.detail.title">ParamedicHospitalAssociation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.paramedicHospitalAssociation.id">Id</Translate>
            </span>
          </dt>
          <dd>{paramedicHospitalAssociationEntity.id}</dd>
          <dt>
            <span id="joiningDt">
              <Translate contentKey="tinyMedicRestApp.paramedicHospitalAssociation.joiningDt">Joining Dt</Translate>
            </span>
          </dt>
          <dd>{paramedicHospitalAssociationEntity.joiningDt}</dd>
          <dt>
            <span id="leavingDt">
              <Translate contentKey="tinyMedicRestApp.paramedicHospitalAssociation.leavingDt">Leaving Dt</Translate>
            </span>
          </dt>
          <dd>{paramedicHospitalAssociationEntity.leavingDt}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.paramedicHospitalAssociation.active">Active</Translate>
            </span>
          </dt>
          <dd>{paramedicHospitalAssociationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.paramedicHospitalAssociation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{paramedicHospitalAssociationEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.paramedicHospitalAssociation.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{paramedicHospitalAssociationEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.paramedicHospitalAssociation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{paramedicHospitalAssociationEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.paramedicHospitalAssociation.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{paramedicHospitalAssociationEntity.timestampEntry}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.paramedicHospitalAssociation.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{paramedicHospitalAssociationEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.paramedicHospitalAssociation.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{paramedicHospitalAssociationEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.paramedicHospitalAssociation.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{paramedicHospitalAssociationEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.paramedicHospitalAssociation.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{paramedicHospitalAssociationEntity.modifiedByID}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicHospitalAssociation.paramedic">Paramedic</Translate>
          </dt>
          <dd>{paramedicHospitalAssociationEntity.paramedic ? paramedicHospitalAssociationEntity.paramedic.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicHospitalAssociation.hospital">Hospital</Translate>
          </dt>
          <dd>{paramedicHospitalAssociationEntity.hospital ? paramedicHospitalAssociationEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/paramedic-hospital-association" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/paramedic-hospital-association/${paramedicHospitalAssociationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParamedicHospitalAssociationDetail;
